import apiPaths from '../api-paths';

export default {
  store({ zuspackage }) {
    return axios.post(`${ apiPaths.API }/zus/packages`, zuspackage);
  },
  show({ id }) {
    return axios.get(`${ apiPaths.API }/zus/packages/${ id }`);
  },
  downloadKedu({ zuspackageId }) {
    return axios.get(`${ apiPaths.API }/zus/packages/${ zuspackageId }/download-kedu`);
  },
  signAndSendToZus({ zuspackageId, data }) {
    return axios.post(`${ apiPaths.API }/zus/packages/${ zuspackageId }/send`, data);
  },
  getStatus({ zuspackageId }) {
    return axios.get(`${ apiPaths.API }/zus/packages/${ zuspackageId }/status`);
  },
  printConfirmationFromZus({zuspackageId}, params = {}) {
    return axios
      .get(
        `${ apiPaths.API }/zus/packages/${zuspackageId}/print-confirmation`,
        {
          params,
        },
      );
  },
};
